export const OPENAI_SIZE_MAP: Record<string, Record<string, string>> = {
    '1k': {
        '1:1': '1024x1024',
        '16:9': '1280x720',
        '9:16': '720x1280',
        '4:3': '1152x864',
        '3:4': '864x1152',
        '5:4': '1120x896',
        '4:5': '896x1120',
        '3:2': '1536x1024',
        '2:3': '1024x1536',
        '2:1': '1536x768',
        '1:2': '768x1536',
        '3:1': '1440x480',
        '1:3': '480x1440',
        '21:9': '1456x624',
        '9:21': '624x1456',
    },
    '2k': {
        '1:1': '2048x2048',
        '16:9': '2048x1152',
        '9:16': '1152x2048',
        '4:3': '2304x1728',
        '3:4': '1728x2304',
        '5:4': '2240x1792',
        '4:5': '1792x2240',
        '3:2': '2048x1360',
        '2:3': '1360x2048',
        '2:1': '3072x1536',
        '1:2': '1536x3072',
        '3:1': '2048x688',
        '1:3': '688x2048',
        '21:9': '2912x1248',
        '9:21': '1248x2912',
    },
    '4k': {
        '1:1': '2880x2880',
        '16:9': '3840x2160',
        '9:16': '2160x3840',
        '4:3': '3264x2448',
        '3:4': '2448x3264',
        '5:4': '3200x2560',
        '4:5': '2560x3200',
        '3:2': '3504x2336',
        '2:3': '2336x3504',
        '2:1': '3840x1920',
        '1:2': '1920x3840',
        '3:1': '3840x1280',
        '1:3': '1280x3840',
        '21:9': '3840x1648',
        '9:21': '1648x3840',
    },
};

const RATIO_SET = new Set(Object.keys(OPENAI_SIZE_MAP['1k']));
export const ALL_RATIOS = [...RATIO_SET];

const RESOLUTION_TIER: Record<string, string> = {
    '1K': '1k', '2K': '2k', '3K': '2k', '4K': '4k', '8K': '4k',
};

export function resolveOpenaiSize(ratio: string | undefined, resolution: string | undefined): string {
    const tierKey = RESOLUTION_TIER[(resolution ?? '1K').toUpperCase()] ?? '1k';
    const ratioKey = ratio && RATIO_SET.has(ratio) ? ratio : '1:1';
    return OPENAI_SIZE_MAP[tierKey][ratioKey];
}
